import React from 'react';

import {
  mediaTabletAndLarger,
  mediaLargeAndLarger,
  mediaHugeAndLarger,
  containerWidthTabletAndLarger,
  containerWidthLargeAndLarger,
  containerWidthHugeAndLarger,
} from '~/components/shared/viewPorts';
import { styled } from '~/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 15px;
  margin: 0 auto;
  ${mediaTabletAndLarger} {
    width: ${containerWidthTabletAndLarger}px;
  }
  ${mediaLargeAndLarger} {
    width: ${containerWidthLargeAndLarger}px;
  }
  ${mediaHugeAndLarger} {
    width: ${containerWidthHugeAndLarger}px;
  }
`;

interface Props {
  children: React.ReactNode;
}

export default ({ children }: Props) => {
  return <Container>{children}</Container>;
};
